// Kennesaw State's undergraduate majors (#2652). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's Academic Programs page
// (catalog.kennesaw.edu, catoid=84), which lists every program under the
// college that offers it and the degree type: every bachelor's line kept,
// minors, pre-baccalaureate certificates and the Journey Honors College's
// non-degree program left out (the honors college offers no bachelor's
// major). Degree abbreviations are the catalog's own (B.S., BBA, BSIT,
// B.S.S.W.E., ...). The catalog spells "College of The Arts"; the name here
// uses a lowercase "the". The Architecture flag quotes KSU's freshman
// admission page (the college file's `firstYear` source). The KB's majors
// list was the starting point; the catalog wins.
const majors = {
    "slug": "kennesaw-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in KSU's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Clarice C. and Leland Bagwell College of Education",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Early Childhood Education Birth through Kindergarten",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Learning, Design, and Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "B.S."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S.Ed."
                }
            ]
        },
        {
            "name": "College of Architecture and Construction Management",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Architecture",
                    "degree": "B.Arch",
                    "flag": "Higher admission requirements and limited seats; KSU encourages you to apply with all documents by January 31.",
                    "flagSource": "firstYear"
                }
            ]
        },
        {
            "name": "College of Computing and Software Engineering",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Game Design and Development",
                    "degree": "BSCGDD"
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science and Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Information Technology",
                    "degree": "BSIT"
                },
                {
                    "name": "Software Engineering",
                    "degree": "B.S.S.W.E."
                },
                {
                    "name": "Information Technology",
                    "degree": "BAS"
                }
            ]
        },
        {
            "name": "College of Science and Mathematics",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "BSES"
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Michael J. Coles College of Business",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "Financial Technologies",
                    "degree": "B.S."
                },
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BBA"
                },
                {
                    "name": "Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Professional Sales",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "Norman J. Radow College of Humanities and Social Sciences",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Modern Language and Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "English Education",
                    "degree": "B.S."
                },
                {
                    "name": "Geospatial Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "History Education",
                    "degree": "B.S."
                },
                {
                    "name": "Interactive Design",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism and Emerging Media",
                    "degree": "B.S."
                },
                {
                    "name": "Media and Entertainment",
                    "degree": "B.S."
                },
                {
                    "name": "Organizational and Professional Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Robert S. Geer Family College of the Arts",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre and Performance Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Digital Animation",
                    "degree": "BFA"
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                }
            ]
        },
        {
            "name": "Southern Polytechnic College of Engineering and Engineering Technology",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechatronics Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Wellstar College of Health and Human Services",
            "source": {
                "label": "KSU 2026-2027 Undergraduate Catalog, Academic Programs",
                "url": "https://catalog.kennesaw.edu/content.php?catoid=84&navoid=9371"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health and Physical Activity Leadership",
                    "degree": "B.S."
                },
                {
                    "name": "Human Services",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Health Science",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Sport Management",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
